import { render, staticRenderFns } from "./RadioRevealer.vue?vue&type=template&id=2d82f9a4"
import script from "./RadioRevealer.vue?vue&type=script&lang=ts"
export * from "./RadioRevealer.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports